import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { VscOrganization } from "react-icons/vsc";
import { AppContext } from "../../AppProvider";
import { HoverEffect } from "../../Components/ui/card-hover-effect";
import { ImagesSlider } from "../../Components/ui/images-slider";
import CBSGCharLoader from "../../Page/CBSGCharLoader";

const Organization_Development = () => {
  const { images, uri, loading, IntroData,About } = useContext(AppContext);
  const [SubServiceAreas, setSubServiceAreas] = useState([]);
  const [loading1, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ODfilteredImages = images.filter(
    (image) => image.caption && image.caption.toLowerCase().includes("od")
  );
  // console.log(ODfilteredImages, images);
  useEffect(() => {
    AOS.init({ duration: 1000,offset: 10 });
    axios
      .get(`${uri}sub-service-areas/`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setSubServiceAreas(res.data.filter((item) => item.category === "OD"));
        } else {
          console.error("Invalid response data format:", res.data);
        }
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {loading ? (
        <CBSGCharLoader />
      ) : (
        <ImagesSlider
          className="h-[30rem] rounded-t border-t border-l border-r border-gray-300"
          images={ODfilteredImages.map((item) => item.image)}
          overlay={true}
        >
          <motion.div
            initial={{ opacity: 0, y: -80 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            className="z-50 flex flex-col justify-center items-center"
          >
            <motion.p className="font-extrabold text-xl md:text-6xl text-center py-4
        p-6 rounded-lg  text-white text-opacity-30 bg-clip-text  bg-center hover:backdrop-blur-md backdrop-filter hover:text-opacity-60">
              Organization Development
            </motion.p>
          </motion.div>
        </ImagesSlider>
      )}
      <p
        className="text-sm md:text-base lg:text-xl font-semibold min-h-10 bg-gradient-to-tr from-base_900 to-base_500 text-white flex items-center justify-start  px-3 mx-10 mb-2 gap-3 mt-8"
        data-aos="fade-right"
      >
        <span className="text-xl">
          {" "}
          <VscOrganization />
        </span>
        ORGANIZATION AND INSTITUTION DEVELOPMENT
      </p>
      <div
        dangerouslySetInnerHTML={{
          __html:
            IntroData?.organization_development_text ||
            "<p>No content available</p>",
        }}
        className="text-base font-sans font-normal text-blue-950 text-justify px-10 py-10"
        data-aos="fade-right"
      />

      {loading1 ? (
        <CBSGCharLoader />
      ) : error ? (
        <p>Error loading data</p>
      ) : (
        <HoverEffect items={SubServiceAreas} />
      )}
      <div className="flex justify-center items-center mb-5">
        <a
          href={About?.major_complemented_assignment_for_od}
          download="Major_Complemented_Assignments_OD.pdf"
          className="btn flex justify-center items-center bg-gradient-to-tr from-base_900 to-base_500 text-white"
        >
          Click to download major complemented organization development assignments since 2003
        </a>
      </div>
    </div>
  );
};

export default Organization_Development;
